import { FetchUtil } from "../util/FetchUtil";
import { HealioErrorModal } from "../components/healioGlobal/HealioErrorModal"
import { WyanokeUtil } from "../util/WyanokeUtil";
import { IQuikQuizServiceEndpoint } from "../models/QuikQuiz/IQuikQuizServiceEndpoint";
import { IQuikQuizGetCurrentTakeResponse } from "../models/QuikQuiz/IQuikQuizGetCurrentTakeResponse"
import { Cookie } from "../util/CookieUtil";

export class QuikQuizService {
  constructor(private readonly _endpoint: IQuikQuizServiceEndpoint) { }

  public async getCurrentTake(
    quizId : string,
    activityId : string
  ):Promise<IQuikQuizGetCurrentTakeResponse | null> {
    const endpoint = this._endpoint.getCurrentTake;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    let anonymousId = Cookie.getCookie("anonid");
    const profile = await WyanokeUtil.loadUserProfile(true, false);
    if (!profile && !anonymousId) {
      return null;
    }

    const contactId = profile?.contactid || "";
    const values = {
        contactid: contactId,
        anonymousid: anonymousId || "",
        activityId: activityId,
        quizId: quizId
    };

    const raw = await FetchUtil.sendMessage(
        endpoint,
        values,
        "default",
        false
      );

      if (typeof raw !== "object") {
        const msg = "Unexpected response from server";
        console.error(msg, raw);
        HealioErrorModal.triggerHealioErrorModalEvent();
        return null;
      }

      return raw as IQuikQuizGetCurrentTakeResponse;
  }
}
